import { WarningOutlined } from '@ant-design/icons';
import { useMemo } from 'react';
import styled from 'styled-components';

import { CenterFlex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import { CHART_TERM_TYPE } from '@/entities/chart/model/constants';
import chartUtils from '@/features/(charts)/chart-renderer/lib/chart-utils';
import useColor from '@/hooks/domain/useColor';
import { radius } from '@/styles/sizes';

type Props = {
  term: ChartTermDef;
};

const TermValidateDisplay = (props: Props) => {
  const color = useColor();
  const isValidate = useMemo(() => {
    if (props.term.type === CHART_TERM_TYPE.PERIODIC) {
      return chartUtils.validateTermLength(props.term.value, props.term.unit);
    }
    return {
      validate: true,
    };
  }, [props.term]);

  if (isValidate.validate) return null;

  return (
    <Style g={10}>
      <WarningOutlined style={{ color: color.destructive, fontSize: 16 }} />
      <Typo type="label2" color="gray700">
        {isValidate.message}
      </Typo>
    </Style>
  );
};

const Style = styled(CenterFlex)`
  background-color: ${(props) => props.theme.colors.error_bg};
  padding: 4px;
  width: 100%;
  border-radius: ${radius.token.sm}px;
`;

export default TermValidateDisplay;
